export class MDStateGovernmentBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public dateOfJoining: string,
        public stateGovernmentDept: string,
        public isStampReadable: string,
        public isStampFromSameDept: string,
        public isSignaturePresent: string,
        public isDateOfIssuePresent: string,
        // public isQRCodePresent: string,
    ) { }
}